import React from 'react';
import cn from '../../../../lib/bem/index';

import './menuStepper_Component.scss';

const MenuStepperComponent = ({onClickRegresar, indice}) => {

    const classes = cn("menuStepperComponent");

    const setStyleDiv = (indice, section) => {
        if( indice === section){
            return 'menuStepperComponentDiv';
        } else if ( indice < section){
            return 'menuStepperComponentDivNoSelected';
        } else {
            return 'menuStepperComponentDivSelected';
        }
    }

    const setStyleNumber = (indice, section) => {
        if( indice === section){
            return 'menuStepperComponentNumber';
        } else if ( indice < section){
            return 'menuStepperComponentNumberNoSelected';
        } else {
            return 'menuStepperComponentNumberSelected';
        }
    }

    const setStyleText = (indice, section) => {
        if( indice === section){
            return 'menuStepperComponentText';
        } else if ( indice < section){
            return 'menuStepperComponentTextNoSelected';
        } else {
            return 'menuStepperComponentTextSelected';
        }
    }

    const setStyleLine = (indice, section) => {
        if( indice > section){
            return 'menuStepperComponentLine';
         } else {
            return 'menuStepperComponentNoLine';
        }
    }

    return (
        <div className={classes()}> 
            <div className={classes(setStyleDiv(indice,1))} onClick={()=> indice > 1 ? onClickRegresar(1) : null }>
                <div>
                    <div className={classes(setStyleNumber(indice,1))}>
                        <p><b>1</b></p>
                    </div>
                </div>
                <div className={classes(setStyleText(indice,1))}>
                    <p><b>PASO 1</b></p>
                    <p>Datos personales</p>
                </div>
            </div>
            <div className={classes(setStyleLine(indice,1))} >

            </div>
            <div className={classes(setStyleDiv(indice,2))} onClick={()=> indice > 2 ? onClickRegresar(2) : null }>
                <div>
                    <div className={classes(setStyleNumber(indice,2))}>
                        <p><b>2</b></p>
                    </div>
                </div>
                <div className={classes(setStyleText(indice,2))}>
                    <p><b>PASO 2</b></p>
                    <p>Simula</p>
                </div>
            </div>
        </div>
    );
};

export default MenuStepperComponent;